// extracted by mini-css-extract-plugin
export default {"skipLink":"App_skipLink__OIU9U"};